import { getRetailerId, isChainHeadSelector, isRetailerDashboardSelector, isStoreProfileSelector, isSuperChainSelector } from 'selectors';
import { setActiveTab } from 'utils/actions/active-tab/active-tab.actions';
import { checkAccess } from 'app/actions/app.actions';

import { fetchPricePointsDictionary } from 'app/actions/dictionaries/price-points-dictionary.actions';
import template from './inventory-tabs.html';

const tabs = {
  games: 'games',
  packs: 'packs',
  liability: 'liability',
  orderHistory: 'orderHistory',
  inventoryHistory: 'inventoryHistory',
};

const mapStateToThis = ({ session, ui, retailerDashboards, dictionary }) => {
  const { activeTab } = ui;
  const { locale, retailer } = session;
  const isStoreProfile = isStoreProfileSelector({ session });
  const retailerIdFromSession = getRetailerId({ session });
  const isRetailerDashboard = isRetailerDashboardSelector({ retailerDashboards });
  const isSuperChain = isSuperChainSelector({ session });
  const isChainHead = isChainHeadSelector({ session });
  const isChainHeadOrSuperChain = isChainHead || isSuperChain;
  const terms = dictionary.terms[locale];

  return {
    retailer,
    retailerIdFromSession,
    isStoreProfile,
    isRetailerDashboard,
    isChainHeadOrSuperChain,
    tabs,
    activeTab,
    terms,
  };
};

const mapDispatchToThis = {
  setActiveTab,
  checkAccess,
  fetchPricePointsDictionary,
};

// eslint-disable-next-line no-undef
@Inject(
  '$ngRedux',
  '$rootScope',
  '$state',
  '$stateParams',
  '$location',
  '$sanitize',
  'Notifications',
  'AlertService',
  'gettextCatalog',
  '$sce'
)
class InventoryTabsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.retailerId = parseInt(this.$state.params.retailerNo, 10) || this.retailerIdFromSession;
    this.canViewLiabilityTab = this.checkAccess('dashboard.widget.currentInstantGameLiability');

    this.initTab = this.getInitTab();

    this.onTabSelect(this.initTab);

    await this.fetchPricePointsDictionary();
  }

  $onDestroy() {
    this.setActiveTab('', 'activeTab');
    this.unsubscribe();
  }

  getInitTab() {
    if (this.$stateParams.tabId) return this.$stateParams.tabId;

    if (this.isChainHeadOrSuperChain) return this.tabs.orderHistory;

    return this.tabs.games;
  }

  onTabSelect(tabId) {
    this.setActiveTab(tabId, 'activeTab');

    // eslint-disable-next-line default-case
    switch (tabId) {
      case 'games':
        this.$rootScope.title = this.gettextCatalog.getString('Games');
        break;
      case 'packs':
        this.$rootScope.title = this.gettextCatalog.getString('{{ pack }}', { pack: this.terms.PACK.plural });
        break;
      case 'liability':
        this.$rootScope.title = this.gettextCatalog.getString('Liability');
        break;
      case 'orderHistory':
        this.$rootScope.title = this.gettextCatalog.getString('Orders');
        break;
      case 'inventoryHistory':
        this.$rootScope.title = this.gettextCatalog.getString('History');
        break;
    }
  }
}

export default class InventoryTabsComponent {
  constructor() {
    this.controller = InventoryTabsController;
    this.template = template;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/inventory-tabs/inventory-tabs-component.js